import styled from 'styled-components'
import { mediaqueries } from '../../utils/mediaqueries'
import { Brevier } from '~/components/Typography'

export const Img = styled.img`
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const StyledContainer = styled.div`
  padding: 0 !important;
  display: flex;
  width: 100%;
  border-bottom: 1px solid ${({ theme: { color } }) => color('accent', 90)};
`

export const StyledRow = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  flex-wrap: wrap;

  flex-flow: column;

  @media ${mediaqueries.md} {
    min-height: calc(100vh - 80px);
    flex-flow: initial;
  }
`

export const ImageCol = styled.div`
  position: relative;
  flex: 0 0 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme: { color } }) => color('accent', 80)};
  padding: 1rem calc((100% - 170px) / 2) 2.3rem;
  max-height: 290px;
  border-bottom: 1px solid ${({ theme: { color } }) => color('accent', 90)};

  @media ${mediaqueries.sm} {
    max-height: 550px;
    padding: 1.5rem calc((100% - 300px) / 2) 4rem;
  }

  @media ${mediaqueries.md} {
    padding: ${({ theme: { toRem } }) => toRem(50)} 15%;
    flex: 0 0 70%;
    max-width: 70%;
    max-height: 100vh;
    //min-height: 100%;
    position: sticky;
    align-items: flex-start;
    top: 0;
    border-bottom: 0;
  }

  @media ${mediaqueries.md} {
    padding: ${({ theme: { toRem } }) => toRem(75)} 19%;
  }
`

export const FormCol = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  @media ${mediaqueries.md} {
    flex: 0 0 30%;
    max-width: 30%;
  }
`

export const ZoomPreview = styled.div`
  background: rgba(255, 255, 255, 0.9);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 15% 10%;
  z-index: 1000;
  max-height: 100vh;
  span {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 30px;
    height: 30px;

    &:before,
    &:after {
      position: absolute;
      left: 12px;
      content: ' ';
      height: 28px;
      width: 2px;
      background-color: #333;
    }

    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }

  @media ${mediaqueries.sm} {
    padding: 5% 22%;
  }

  @media ${mediaqueries.md} {
    display: none;
  }
`

export const HelpText = styled(Brevier)`
  font-style: italic !important;
  position: absolute;
  bottom: 5px;
  font-size: 10px !important;
  color: #9ba4b8;

  @media ${mediaqueries.sm} {
    bottom: 10px;
    font-size: 11px !important;
  }

  @media ${mediaqueries.md} {
    display: none;
  }
`
